import { Col, List, Row, Card, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { AlertBanner } from "views/Profile/components/viewAlertBanner";
import { AddressInfo } from "views/Profile/components/viewAddressInfo";
import { AvatarProfile } from "views/Profile/components/viewAvatarProfile";
import { BasicInfo } from "views/Profile/components/viewBasicInfo";
import { EducationItem } from "views/Profile/components/viewEducationItem";
import { ExperienceItem } from "views/Profile/components/viewExperienceItem";
import { CertificateItem } from "views/Profile/components/viewCertificateItem";
import { CvItem } from "views/Profile/components/viewCvItem";
import { useGetEnumeratorProfileInfo } from "api/enumerator/Profile/useGetProfile";
import { storage } from "utils/storage";

const EnumeratorDetails = () => {
  const user_id = storage.getUserFromStorage().uid;
  const { data: user } = useGetEnumeratorProfileInfo(user_id);
  const navigate = useNavigate();
  if (!user) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="bg-background">
      <div className="max-w-6xl mx-auto py-12">
        <Row>
          <Col span={24}>
            <AlertBanner onUpdateClick={() => navigate(`/enumerator/profile/update`)} />
          </Col>
        </Row>

        <Row gutter={[24, 24]} className="mt-6">
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <AvatarProfile user={user} />
          </Col>
          <Col xs={24} sm={24} md={16} lg={16} xl={16}>
            <Card><BasicInfo user={user} /></Card>
            {user?.temporaryAddress && <AddressInfo title="Temporary Address" address={user.temporaryAddress} />}
            {user?.permanentAddress && <AddressInfo title="Permanent Address" address={user.permanentAddress} />}

            <Card className="mt-6" title="Educational Background">
              <List
                dataSource={user?.educationalBackground || []}
                renderItem={(item) => <EducationItem item={item} />}
              />
            </Card>

            <Card className="mt-6" title="Certificates">
              <List
                dataSource={user?.certificates || []}
                renderItem={(item) => <CertificateItem item={item} />}
              />
            </Card>
            <Card className="mt-6" title="CV">
              <List
                dataSource={user?.cv ? [user.cv] : []}
                renderItem={(item) => <CvItem item={item} />}
              />
            </Card>
            <Card className="mt-6" title="Experience">
              <List
                dataSource={user?.experience || []}
                renderItem={(item) => <ExperienceItem item={item} />}
              />
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default EnumeratorDetails;
